import { doc, getDoc } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { firestore } from '../services/firebase';
import type { Account } from '../types/account';
import type { Tender } from '../types/tender';
import { getRecentTenderIds } from '../utils/recentTenders';

export const useRecentTenders = (account: Account | null) => {
  const [recentTenders, setRecentTenders] = useState<Tender[]>([]);

  useEffect(() => {
    if (!account?.uid || !account?.clientId) {
      setRecentTenders([]);
      return;
    }

    const fetchTenders = async () => {
      const ids = getRecentTenderIds(account.uid);
      if (ids.length === 0) {
        setRecentTenders([]);
        return;
      }

      const fetched: Tender[] = [];
      for (const id of ids) {
        try {
          const docRef = doc(firestore, 'tenders', id);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            // Ensure the user actually has access to this tender
            if (data.clientId === account.clientId && data.archived === false) {
              fetched.push({ id: docSnap.id, ...data } as Tender);
            }
          }
        } catch (_e) {
          // Ignore individual fetch errors
        }
      }
      setRecentTenders(fetched);
    };

    fetchTenders();

    const handleUpdate = () => {
      fetchTenders();
    };

    window.addEventListener('recentTendersUpdated', handleUpdate);
    return () => window.removeEventListener('recentTendersUpdated', handleUpdate);
  }, [account?.uid, account?.clientId]);

  return recentTenders;
};
